import { render, staticRenderFns } from "./projectsDates.vue?vue&type=template&id=ffcdd056&"
import script from "./projectsDates.vue?vue&type=script&lang=js&"
export * from "./projectsDates.vue?vue&type=script&lang=js&"
import style0 from "./projectsDates.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports